import { render, staticRenderFns } from "./calc.vue?vue&type=template&id=c854584a&scoped=true"
import script from "./calc.vue?vue&type=script&lang=js"
export * from "./calc.vue?vue&type=script&lang=js"
import style0 from "./calc.vue?vue&type=style&index=0&id=c854584a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c854584a",
  null
  
)

export default component.exports